/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { templatesGet } from "../funcs/templatesGet.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { GetPromptTemplateResult } from "../models/components/getprompttemplateresult.js";
import {
  GetTemplateRequest,
  GetTemplateSecurity,
} from "../models/operations/gettemplate.js";
import { unwrapAsync } from "../types/fp.js";
export type TemplateQueryData = GetPromptTemplateResult;

export function prefetchTemplate(
  queryClient: QueryClient,
  client$: GramCore,
  request?: GetTemplateRequest | undefined,
  security?: GetTemplateSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildTemplateQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildTemplateQuery(
  client$: GramCore,
  request?: GetTemplateRequest | undefined,
  security?: GetTemplateSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (context: QueryFunctionContext) => Promise<TemplateQueryData>;
} {
  return {
    queryKey: queryKeyTemplate({
      id: request?.id,
      name: request?.name,
      gramKey: request?.gramKey,
      gramSession: request?.gramSession,
      gramProject: request?.gramProject,
    }),
    queryFn: async function templateQueryFn(ctx): Promise<TemplateQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(templatesGet(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyTemplate(
  parameters: {
    id?: string | undefined;
    name?: string | undefined;
    gramKey?: string | undefined;
    gramSession?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "templates", "get", parameters];
}
